module.exports = __webpack_public_path__ + "static/media/20-10.28d2b1e2.mp3";